import { Title } from "../../../../components/Title/Title";
import { Image } from "../../../../components/Image/Image";
import { useRegistrationSection } from "../../../../providers/RegistrationSectionProvider/useRegistrationData";
import styles from "./Download.module.scss";
import cn from "classnames";
import { useUserData } from "../../../../providers/UserDataProvider/useUserData";
import { useEffect, useRef } from "react";
import { ampAppDownloadClick } from "../../../../utils/AmplitudeEvents";
export const DownloadBlock = ()=>{
  const {content } = useRegistrationSection();
  const { userData } = useUserData();
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      const el = videoRef.current;
      if (!el.src && el.dataset.src) {
        el.src = el.dataset.src;
      }

      el.load();
      el.play().catch((err) => {
        console.warn("Couldn't start the video:", err);
      });
    }
  }, []);
  if (!content) {
    return;
  }
  const {buddy, title, linksTitle, actionText,video,farewell } = content;
  let count =1;
  const appEmail = userData?.appEmail
  ? encodeURIComponent(userData.appEmail)
  : 'test%40gmail.com';
  
  // !!! TO-DO заменить ссылки
  const buttons ={
    'ios' : `https://haaaaaaappy.onelink.me/A1zF/neqijxo8?deep_link_value=${appEmail}`,
    'android' : `https://hapday.onelink.me/xBiS/ly1bsvbi?deep_link_value=${appEmail}`
  }
  return (
    <div className={styles.wrapper}>
      {buddy && <Image src={buddy} className={styles.buddy}/> }
      {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }} />}
      {buttons && (
        <>
        <div className={styles.count}>{count++}</div>
        {linksTitle && <Title className={cn(
          styles.linksTitle,
          'download_title'
        )} dangerouslySetInnerHTML={{ __html:linksTitle }} />}
        <div className={styles.buttons}>
          {buttons.ios && (
            <a href={buttons.ios} className={styles.button} target="_blank" onClick={ampAppDownloadClick}>
              <Image src="/assets/download/ios.svg" />
            </a>
          )}
          {buttons.android && (
            <a href={buttons.android} className={styles.button} target="_blank" onClick={ampAppDownloadClick}>
              <Image src="/assets/download/android.svg" />
            </a>
          )}
        </div>
        </>
        
      )}
      {actionText && (
        <>
        <div className={styles.count}>{count++}</div>
        <Title className={cn(styles.actionText,'download_title')} dangerouslySetInnerHTML={{ __html:actionText }} />
        {video && <video ref={videoRef} src={video} className={styles.video} muted playsInline loop autoPlay></video>}
        </>
      )}
      {farewell && (
        <>
        <div className={styles.count}>{count++}</div>
        <Title className={styles.farewell} dangerouslySetInnerHTML={{ __html:farewell }} />
        </>
      )}
    </div>
  )
}
